module.exports = __webpack_public_path__ + "static/media/16.2cf9dfb3.jpg";